import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'
import classNames from 'classnames'

import {
    getEndDateMessage,
} from 'helpers/datetime'

import Timer from 'components/Timer/Timer.jsx'

import { UNIT_TYPES } from 'constants'
import { STATUS_MESSAGES } from './constants.jsx'
import { SORTIES_END_INTERIM } from '../../constants.jsx'

import { CHALLENGES_END } from 'helpers/i18n.jsx'

import styles from './Status.scss'

export default class Status extends React.Component {
    static propTypes = {
        primetimeStart: PropTypes.number,
        primetimeEnd: PropTypes.number,
        isAvailable: PropTypes.bool,
        type: PropTypes.oneOf(Object.values(UNIT_TYPES)).isRequired,
    }
    static defaultProps = {
        isAvailable: false,
    }

    getTimer(){
        const { primetimeStart, primetimeEnd, type } = this.props

        if (!this.props.isAvailable) {
            return {
                timer: getEndDateMessage(moment(primetimeStart)),
                status: STATUS_MESSAGES.STARTS_NOT_SOON,
                expiresSoon: false,
            }
        }

        if (type === UNIT_TYPES.SORTIE) {
            const mSecondsTillStart = (primetimeStart ? primetimeStart - Date.now() : null)
            const mSecondsTillEnd = (primetimeEnd ? primetimeEnd - Date.now() : null)

            if (primetimeStart && primetimeEnd && (primetimeStart < primetimeEnd) && (mSecondsTillStart > 0)) {
                return {
                    status: STATUS_MESSAGES.STARTS_SOON,
                    timer: (<Timer endTime={moment(primetimeStart)} shortFormat />),
                    expiresSoon: true,
                }
            } else if (mSecondsTillEnd && (mSecondsTillEnd < SORTIES_END_INTERIM)) {
                return {
                    status: CHALLENGES_END,
                    timer: (<Timer endTime={moment(primetimeEnd)} shortFormat />),
                    expiresSoon: true,
                }
            } else {
                return {
                    status: STATUS_MESSAGES.BATTLES_AVAILABLE,
                    timer: null,
                    expiresSoon: false,
                }
            }
        } else if (type === UNIT_TYPES.FORT_BATTLE) {
            return {
                status: STATUS_MESSAGES.STARTS_SOON,
                timer: (<Timer endTime={moment(primetimeStart)} shortFormat />),
                expiresSoon: true,
            }
        }
    }

    render() {
        const { status, timer, expiresSoon } = this.getTimer()
        const className = classNames(styles.base, {
            [styles.base__soon]: expiresSoon,
        })
        return (
            <div className={className}>
                <div className={styles.holder}>
                    <div className={styles.content}>
                        <p className={styles.title}>{status}</p>
                        <p className={styles.timer}>{timer}</p>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Status/Status.jsx